import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { ResponseObject } from '../../interfaces/App';
import {
  createZapierApiKey,
  listZapierApiKeys,
  revokeZapierApiKey,
  ZapierApiKeysListResponse,
} from '../../services/integrationsService';

export const zapierApiKeysQueryKey = [
  'integrations',
  'zapier',
  'api-keys',
] as const;

export const useZapierApiKeys = (enabled = true) => {
  return useQuery<ResponseObject, Error>({
    queryKey: zapierApiKeysQueryKey,
    queryFn: () => listZapierApiKeys(),
    enabled,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
    select: data => ({
      ...data,
      message: data.message as ZapierApiKeysListResponse,
    }),
  });
};

export const useZapierApiKeyMutations = () => {
  const queryClient = useQueryClient();

  const invalidate = () => {
    void queryClient.invalidateQueries({ queryKey: zapierApiKeysQueryKey });
  };

  const createKey = useMutation({
    mutationFn: () => createZapierApiKey(),
    onSuccess: invalidate,
  });

  const revokeKey = useMutation({
    mutationFn: (keyId: string) => revokeZapierApiKey(keyId),
    onSuccess: invalidate,
  });

  return { createKey, revokeKey };
};
